import request from '@/utils/request';

const projectName = '/api/blade-platform';

const dynamicMan = {
  state: {
  },
  mutations: {
  },
  actions: {
    /**
     * 条件查询动态列表
     * @param {*} param0 context
     */
    getDynamicList({ commit }, data) {
      return request({
        url: `${projectName}/platformalumniaction/getDynamicList`,
        method: 'post',
        data,
      }).then((res) => {
        return Promise.resolve(res);
      });
    },
  },
};

export default dynamicMan;
